import { MovementTabView } from "../../../dispatch/src/MovementTabView";
import { Billing } from "../Billing";
import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutViewBilling extends Layout {
    layoutBilling: Billing;
    layoutMovementTabView: MovementTabView;
}
